<template>
  <div id="submenu">
    <div class="container">
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="black-box"></div>
      <swiper :options="swiperOption">

        <swiper-slide v-for="(value, key) in services" v-bind:key="key">
          <router-link :to="value.url">
            <div class="caption">{{ value.title }}</div>
            <div class="box"><img :src="value.img" alt=""></div>
          </router-link>
        </swiper-slide>

      </swiper>
      <div class="swiper-button-next" slot="button-next"></div>
    </div>
  </div>
</template>
<script>
  import { swiper, swiperSlide } from 'vue-awesome-swiper'

  export default {
    components: {
      swiper,
      swiperSlide
    },
    data () {
      return {
        services: [
          {
            title: 'Компьютерная диагностика',
            url: '/service/comp',
            img: '/static/services/comp.png'
          },
          {
            title: 'Ремонт дизельных двигателей',
            url: '/service/engine',
            img: '/static/services/engine.png'
          },
          {
            title: 'Ремонт топливной аппаратуры',
            url: '/service/topl',
            img: '/static/services/fors.png'
          },
          {
            title: 'Ремонт электрики',
            url: '/service/electric',
            img: '/static/services/electro.png'
          },
          {
            title: 'Ремонт электроники',
            url: '/service/electronic',
            img: '/static/services/electronic.png'
          },
          {
            title: 'Ремонт ходовой',
            url: '/service/hod',
            img: '/static/services/hod.png'
          },
          {
            title: 'Тех. обслуживание',
            url: '/service/to',
            img: '/static/services/oil.png'
          },
          {
            title: 'Ремонт спецтехники',
            url: '/service/spectechnic',
            img: '/static/services/truck.png'
          }
        ],
        swiperOption: {
          slidesPerView: 6,
          nextButton: '.swiper-button-next',
          prevButton: '.swiper-button-prev',
          spaceBetween: 0,
          breakpoints: {
            1024: {
              slidesPerView: 5,
              spaceBetween: 0
            },
            768: {
              slidesPerView: 4,
              spaceBetween: 0
            },
            640: {
              slidesPerView: 3,
              spaceBetween: 0
            },
            480: {
              slidesPerView: 2,
              spaceBetween: 0
            },
            320: {
              slidesPerView: 1,
              spaceBetween: 0
            }
          }
        }
      }
    }
  }
</script>
<style lang="stylus" scoped>
@import '../../common/css/vars'

input, textarea, button, select, a
  -webkit-tap-highlight-color transparent

.router-link-exact-active
  .caption
    color $red
    border-top 3px solid $red

#submenu
  height 100px
  position fixed
  bottom 0
  width 100%
  left 0
  right 0
  margin 0 auto
  background-color #1b1e22
  box-shadow rgba(62, 62, 62, 0.75) 0px 0px 36px 0px

  a
    text-decoration none
    font-size 12px
    font-weight 600

.black-box
  height 30px
  position absolute
  top 0
  left 0
  width 100%
  background-color #040404

.swiper-container
  height 100px
  margin 0 auto
  width 90%

.swiper-slide
  background-size cover
  background-position center
  height 100%

// max-width 150px
.swiper-button-prev, .swiper-button-next
  top 60%
  background-image url('/static/prev-next.png')
  background-size cover
  width 40px
  height 40px
  -webkit-tap-highlight-color transparent

.caption
  height 30px
  font-size 11px
  background-color #040404
  line-height 1
  padding-top 5px
  color darken($white, 20%)

  &:hover
    color $white
    border-top 3px solid $white

.swiper-button-prev, .swiper-button-next
  display none

.box
  box-shadow 0 3px 7px rgba(0, 0, 0, 0.42)
  height 100%
  width 100%
  background-color #ccc
  background linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(230, 230, 230, 1) 50%, rgba(0, 0, 0, 1) 100%)

  img
    position absolute
    margin auto
    top 20%
    left 0
    right 0
    bottom 0
    height 50px

@media only screen and (min-width: 320px)
  .swiper-button-prev, .swiper-button-next
    display block

  .swiper-button-next
    transform rotate(180deg)
    right 15px

  .swiper-button-prev
    left 15px

@media only screen and (min-width: 480px)
  #submenu
    height 150px

  .swiper-container
    height 150px

  .box
    img
      height auto
</style>


// WEBPACK FOOTER //
// Bottom.vue?0596918e